var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightsaber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GD001",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2",
    gradientUnits: "userSpaceOnUse",
    x1: 245.634,
    x2: 260.993,
    y1: 85.642,
    y2: 377.448
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc5c7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#f35e85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#d9659b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#b070bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777ff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a82fb"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-2",
    x1: 127.361,
    x2: 142.72,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: 91.867,
    y2: 383.672
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-3",
    gradientTransform: "matrix(.371 .928 -.928 .371 288.554 5.791)",
    x1: 133.45,
    x2: 148.808,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: 91.546,
    y2: 383.352
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-4",
    gradientTransform: "matrix(.928 .371 -.371 .928 120.876 -26.024)",
    x1: 117.032,
    x2: 132.39,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: 92.411,
    y2: 384.216
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-5",
    gradientTransform: "matrix(.371 .928 -.928 .371 520.666 -167.451)",
    x1: 372.325,
    x2: 387.683,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: 78.974,
    y2: 370.78
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-6",
    x1: 366.698,
    x2: 382.057,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: 79.27,
    y2: 371.076
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-7",
    gradientTransform: "matrix(.928 .371 -.371 .928 106.827 -122.708)",
    x1: 364.809,
    x2: 380.167,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: 79.37,
    y2: 371.175
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-8",
    x1: 253.328,
    x2: 268.686,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: 85.237,
    y2: 377.043
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-9",
    gradientTransform: "matrix(.371 .928 -.928 .371 316.07 -186.823)",
    x1: 293.008,
    x2: 308.366,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: 83.149,
    y2: 374.954
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-10",
    gradientTransform: "matrix(.928 .371 -.371 .928 67.444 -70.207)",
    x1: 213.229,
    x2: 228.587,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: 87.348,
    y2: 379.153
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-11",
    x1: 240.732,
    x2: 256.09,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: 85.9,
    y2: 377.706
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-12",
    gradientTransform: "matrix(.928 .371 -.371 .928 164.126 -84.249)",
    x1: 284.988,
    x2: 300.346,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: 83.571,
    y2: 375.376
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-13",
    gradientTransform: "matrix(.371 .928 -.928 .371 489.313 45.304)",
    x1: 195.635,
    x2: 210.994,
    xlinkHref: "#New_Gradient_Swatch_2",
    y1: 88.274,
    y2: 380.079
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m403.633 373.269 11.313-11.313-11.313-11.314-11.314 11.313-11.314-11.314a8 8 0 0 0 0-11.314l-22.628-22.627a8 8 0 0 0 -8.186-1.932l-3.795 1.265-58.243-58.243 192.8-192.813a23.995 23.995 0 1 0 -33.924-33.943l-192.809 192.822-190-190a24 24 0 0 0 -33.94 33.944l189.993 189.993-39.112 39.107-5.661-5.661a8 8 0 0 0 -11.313 0l-22.627 22.633a8 8 0 0 0 -.912 10.214l-32.023 22.874a8 8 0 0 0 -1.007 12.167l5.657 5.657-11.313 11.316-11.315-11.317-11.313 11.317 11.314 11.313-22.628 22.626-5.657-5.657a8 8 0 0 0 -12.163 1.007l-28.284 39.6a8 8 0 0 0 .853 10.308l33.941 33.941a8 8 0 0 0 10.306.853l39.6-28.284a8 8 0 0 0 1.007-12.167l-5.657-5.657 22.628-22.628 11.306 11.311 11.314-11.314-11.314-11.313 11.313-11.314 5.657 5.657a8 8 0 0 0 5.656 2.343q.33 0 .66-.028a8 8 0 0 0 5.851-3.322l22.873-32.023a7.987 7.987 0 0 0 10.215-.911l22.627-22.628a8 8 0 0 0 0-11.314l-5.66-5.66 39.112-39.112 41.955 41.955a7.967 7.967 0 0 0 -.01 11.3l39.6 39.6a8 8 0 0 0 11.314 0l101.824 101.824a8 8 0 0 0 11.314 0l22.627-22.627a8 8 0 0 0 0-11.314zm0 22.628-11.314 11.313-11.314-11.31 11.314-11.314zm-33.941-11.314-11.313-11.314 11.313-11.314 11.314 11.314zm88.66-342.24a7.995 7.995 0 1 1 11.3 11.31l-192.812 192.823-11.307-11.306zm-419.102 8.485a8 8 0 0 1 13.658-5.656l276.517 276.518-16.97 5.656-270.861-270.86a7.949 7.949 0 0 1 -2.344-5.658zm112.758 284.807 6.521 6.521-22.629 22.627-10.291-10.293zm-94.28 86.739 10.292 10.293-22.628 22.627-6.521-6.522zm5.5 50.755-6.521-6.521 22.627-22.628 10.293 10.293zm27.419-40.463-11.313-11.313 22.628-22.628 11.313 11.313zm33.942-33.941-11.313-11.314 11.313-11.311 11.311 11.311zm32.92-12.335-10.293-10.29 22.627-22.627 6.522 6.522zm34.962-32.919-33.941-33.942 11.314-11.314 33.941 33.941zm11.31-33.946-11.306-11.306 39.112-39.112 11.306 11.306zm112.838 23.3 33.941-11.313 13.475 13.473-22.628 22.628zm137.925 126.611-50.911-50.912 11.313-11.313 50.911 50.911z",
    fill: "url(#New_Gradient_Swatch_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m88 248h96v16h-96z",
    fill: "url(#New_Gradient_Swatch_2-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m132 194.459h16v43.081h-16z",
    fill: "url(#New_Gradient_Swatch_2-3)",
    transform: "matrix(.371 -.928 .928 .371 -112.546 265.763)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m119.384 292.8h17.233v16h-17.233z",
    fill: "url(#New_Gradient_Swatch_2-4)",
    transform: "matrix(.928 -.371 .371 .928 -102.564 69.057)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m376 292.183h16v17.233h-16z",
    fill: "url(#New_Gradient_Swatch_2-5)",
    transform: "matrix(.371 -.928 .928 .371 -37.902 545.616)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m328 248h96v16h-96z",
    fill: "url(#New_Gradient_Swatch_2-6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m350.459 208h43.081v16h-43.081z",
    fill: "url(#New_Gradient_Swatch_2-7)",
    transform: "matrix(.928 -.371 .371 .928 -53.614 153.606)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m248 88h16v96h-16z",
    fill: "url(#New_Gradient_Swatch_2-8)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m274.459 132h43.081v16h-43.081z",
    fill: "url(#New_Gradient_Swatch_2-9)",
    transform: "matrix(.371 -.928 .928 .371 56.092 362.845)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m208 118.459h16v43.081h-16z",
    fill: "url(#New_Gradient_Swatch_2-10)",
    transform: "matrix(.928 -.371 .371 .928 -36.546 90.234)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m248 328h16v96h-16z",
    fill: "url(#New_Gradient_Swatch_2-11)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m292.8 375.384h16v17.232h-16z",
    fill: "url(#New_Gradient_Swatch_2-12)",
    transform: "matrix(.928 -.371 .371 .928 -121.099 139.177)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m202.584 376h17.232v16h-17.232z",
    fill: "url(#New_Gradient_Swatch_2-13)",
    transform: "matrix(.371 -.928 .928 .371 -223.77 437.5)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightsaber);
export default __webpack_public_path__ + "static/media/lightsaber.eb7d4cd665426117002814db79fceef4.svg";
export { ForwardRef as ReactComponent };